// @flow

import { get } from 'lodash';
import { resolve, reject } from 'redux-optimist-promise';
import createReducer from 'Store/utils/createReducer';
const FETCH_TRAVEL_COMPANIONS = 'FETCH_TRAVEL_COMPANIONS';
const UPDATE_TRAVEL_COMPANION = 'UPDATE_TRAVEL_COMPANION';

export const FETCH_TRAVEL_COMPANIONS_RESOLVED = resolve(FETCH_TRAVEL_COMPANIONS);

export const initialState = {
  data: [],
  isLoading: false,
  isLoaded: false,
  errorResponse: {},
};

export default createReducer(initialState, {
  [FETCH_TRAVEL_COMPANIONS](state) {
    return {
      ...state,
      isLoading: true,
    };
  },
  [FETCH_TRAVEL_COMPANIONS_RESOLVED](state, action) {
    return {
      ...state,
      isLoading: false,
      isLoaded: true,
      data: get(action, 'payload.travelCompanions', []),
    };
  },
  [reject(FETCH_TRAVEL_COMPANIONS)](state, action) {
    return {
      ...state,
      isLoading: false,
      isLoaded: false,
      errorResponse: {
        errors: action.payload.errors,
      },
    };
  },
  [UPDATE_TRAVEL_COMPANION](state, action) {
    return {
      ...state,
      data: action.payload,
    };
  },
});
